import { FormsMultilineInput, Spinner } from '@platform/components';
import { Control } from 'react-hook-form';
import { UpdateDiscoveryCallFormData } from '.';

type UnresponsiveContentProps = {
  control: Control<UpdateDiscoveryCallFormData>;
  otherPartyName: string;
  isSaving: boolean;
};

export const UnresponsiveContent = (props: UnresponsiveContentProps) => {
  return (
    <div className='flex flex-col gap-4 md:mt-8 items-center md:w-[500px]'>
      {props.isSaving ?
        <Spinner />
      : <>
          <div className='text-center text-lg'>
            Sorry to hear {props.otherPartyName} has been unresponsive. We'll reach out to them to
            see what's going on, and update you with next steps via email.
          </div>
          <div className='text-center text-lg'>
            If you have any additional details to share, you can do so below.
          </div>
          <div className='mt-4 w-full items-stretch'>
            <div className='text-sm'>Additional details (optional)</div>
            <FormsMultilineInput
              control={props.control}
              name='unresponsiveDetails'
              characterCount={500}
              placeholder='Anything else you want to tell us...'
            />
          </div>
        </>
      }
    </div>
  );
};
